/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { AUTH_STRINGS } from '../../../../../constants/strings';
import FxMaterialSelect from '../../../../Input/FxSelect/FxMaterialSelect';
import FxCard from '../../../../Container/FxCard';
import FxCardBody from '../../../../Container/FxCardBody';
import FxCardFooter from '../../../../Container/FxCardFooter';
import { FxTextEdit } from '../../../../Input/FxText/FxTextEdit';
import FxLabelView from '../../../../Input/FxLabel/FxLabelView';
import { FxButton } from '../../../../Action/FxButton';
import usa_state from '../../../../Utils/usa_states.json'
import {
  ageLimit,
  deleteUnwantedRequest,
  handleKeyDownChange,
  handleZipChange,
  setZipValidationOptions,
  setPhoneValidationOptions,
  convertToPhoneRequestFormat,
  setAddressLine1Validation,
  setSsnValidationOptions,
  setItinValidationOptions,
  ShowInfoToolTip,
  handleFieldChange,
  handleDateValidation,
  handleEmailChange,
  setCityValidation,
  fetchDataFromState,
  secondaryIdentificationIdValidation,
  handleSecIdChange,
  secondaryIDTypeData
} from '../../../../Utils/CommonBaseClass';
import issuance_countries from '../../../../../libs/utils/country/country.json'
import { FxDateEdit } from '../../../../Input/FxDate/FxDateEdit';
import FxPhoneEdit from '../../../../Input/FxPhone/FxPhoneEdit';
import FxCardHeader from '../../../../Container/FxCardHeader';
import { FxTextEditSSN } from '../../../../Input/FxSSN/FxTextEditSSN';
import { FxSelectAutoSearch } from '../../../../Input/FxSelect/FxSelectAutoSearch';
import { useMediaQuery } from 'react-responsive';
import FxRadioEdit from '../../../../Input/FxRadio/FxRadioEdit';
import { FieldErrorMessageRender } from '../../Common/FieldErrorMessageRender';
import { saveNodeData } from '../../../../../libs/utils/autoSaveField';
import { useDispatch, useSelector } from 'react-redux';
import { useIsMobileOrTabletScreen, useIsMobileScreen } from '../../../../../libs/utils/utils';

//component used to add business owner
export const BusinessOwnerAdd: React.FC<any> = React.memo(
    (props) => {
        const { register, formState: { errors, isSubmitting,isValid }, getValues, handleSubmit, setValue, control, clearErrors, setError, watch } = useForm({mode: 'onChange',reValidateMode:'onChange'});
        const [secondaryIdType, setSecondaryIdType] = useState('');
        const [checkBoxValue, setCheckBoxValues] = useState<any>({ authorized: false, creditReport: false })
        const isSmallScreen = useIsMobileOrTabletScreen()
        const isMobileScreen = useIsMobileScreen()
        const taxIdentifier = watch('taxIdentifier') || 'ssn';
        const taxIdentifierData = [
            { label: "SSN", value: "ssn" },
            { label: "ITIN", value: "itin" },
        ];
        const dispatch = useDispatch();

        /**
         * Function to be called before loading the component
         */
        useEffect(() => {
            setCheckBoxValues({ authorized: false, creditReport: false })
        }, []);

       useEffect(() => {
            // Reset the value of the selected taxIdentifier (SSN or ITIN) field when the taxIdentifier changes
            setValue(taxIdentifier, "");
            
            // Clear any errors for the field that is not selected
            clearErrors(taxIdentifier === 'ssn' ? 'itin' : 'ssn');
        }, [taxIdentifier]);


        const usCitizenDropdown:any =[
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
        ]

        //Set Validation condition for Ownership Percentage
        const authSignDate: any = useMemo(() => {
            let requiredField: boolean;
            if (checkBoxValue?.authorized === true && (props.businessDetails?.['businessCategory'] === 'GOVERNMENT_ORGANISATION' || props.businessDetails?.['businessCategory'] === 'NON_PROFIT' || props.businessDetails?.['businessCategory'] === 'TAX_EXEMPTION' || props.businessDetails?.['businessCategory'] === 'LLC' || props.businessDetails?.['businessCategory'] === 'LLP' || props.businessDetails?.['businessCategory'] === 'S-CORP ' || props.businessDetails?.['businessCategory'] === 'C-CORP')) {
                delete errors['ownerShipPercentage']
                requiredField = true
            }
            else {
                requiredField = false
            }
            return requiredField
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [checkBoxValue])

        // Email validation constant
        const setEmailValidationOptions = {
            required: true,
            maxLength: 250,
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i,
                message: AUTH_STRINGS.ERRORS.EMAIL_INVALID_REGEXP,
            },
        };

        // Ownership percentage validation constant
        const setOwnerShipPercentageRule = {
            required: authSignDate === true ? false : true,
            min: 0,
            max: 100
        };

        /**
         * Handles changes for of secondary identification type field.
         *
         * Specifically, if the changed field is 'secondaryIdentificationType',
         * it updates the state and clears any validation errors for the
         * 'secondaryIdentificationId' field.
         *
         * Regardless of the field, it saves the updated data using `saveNodeData`.
         *
         * @param e - The event object from the input field.
         * @param fieldName - The name of the field being changed.
         */
        const handleChange = (e: any, fieldName: string) => {
            if(fieldName === 'secondaryIdentificationType'){
                setSecondaryIdType(e.target.value)
                clearErrors('secondaryIdentificationId')
            }
            saveNodeData('ownership-info-page', fieldName, e, setValue, getValues,  dispatch, businessState, props?.index);
        }

        // Method handles the submit for add beneficial owner form
        function onSubmit(data: any) {
            // If 'ssn' is being used, remove 'itin' from the data.
            // Otherwise, if 'itin' is being used, remove 'ssn' from the data
            if (taxIdentifier === 'ssn') {
                delete data.itin;
            } else {
                delete data.ssn;
            }
            delete data.taxIdentifier;
            const req: any = { ...data };
            if (data['dob']) {
                req['dob'] = moment(data['dob']).format('MM/DD/YYYY');
            }
            req['mailingAddress'] = [{
                "addressLine1": data['addressLine1'],
                "addressLine2": data['addressLine2'],
                "city": data['city'],
                "state": data['state'],
                "zip": data['zip'],
                "isPrimary": true
            }]
            req['businessDetails'] = {
                'ownershipPercentage': data['ownerShipPercentage'],
                'title': data['jobtitle']
            }
            // Set secondary identification object for request, based on type: use state for driver's license, country for others (default to 'US' for alien card)
            req["secondaryIdentification"] = data['secondaryIdentificationType'] === 'DRIVER_LICENSE' ? {
                'type': data['secondaryIdentificationType'],
                'id': data['secondaryIdentificationId'],
                'stateOfIssuance': data['secondaryIdentificationIssuanceState']
            } : {
                'type': data['secondaryIdentificationType'],
                'id': data['secondaryIdentificationId'],
                'countryOfIssuance': data['secondaryIdentificationType'] === 'ALIEN_REGISTRATION_CARD' ? 'US' : data['secondaryIdentificationIssuance']
            }
            req['mobilePhone'] = convertToPhoneRequestFormat(req.mobilePhone)
            if(req['mobilePhone'] === ""){
                delete req['mobilePhone'];
            }
            req['isUSCitizen'] = data['usCitizen']==='yes' ? true : false;
            req['actAsAuthorizedSignatory'] = data.authSignatory === 'yes' ? true : false

            if (!req['businessDetails']['ownershipPercentage']) {
                delete req['businessDetails']['ownershipPercentage'];
            }

            const unwantedRequestArray = ['state', 'addressLine1', 'city', 'zip', 'addressLine2', 'jobtitle', 'authSignatory', 'ownerShipPercentage', 'creditReport', 'secondaryIdentificationType', 'secondaryIdentificationId', 'secondaryIdentificationIssuance', 'secondaryIdentificationIssuanceState','usCitizen','mobilePhone-select'];
            deleteUnwantedRequest(req, unwantedRequestArray)
            if (props.onSubmit) {
                props.onSubmit(data, req, 'add', undefined)
            }

        }

        // Method handles the click operation for going back to business owner list screen
        const handleGoBackClick = () => {
            if (props?.cancel) {
                props.cancel()
            }
        }

        /**
         * Data for the Set As Auth Signatory radio button
         */
        const setAsAuthSignatoryRadioButtonData=[
            { label: 'Yes', value: "yes" },
            { label: 'No', value: "no" },
          ]
      
        /**
         * Method handles the Set As Auth Signatory radio button change event
         * @param event : event parameter
         */
        const handleSetAsAuthSignatoryRadioButtonChange = (event: any) => {
            setValue('authSignatory',event.target.value);
            setCheckBoxValues({ authorized: event.target.value === 'yes' ? true : false});
            saveNodeData('ownership-info-page', 'authSignatory', event, setValue, getValues,  dispatch, businessState, props?.index)
        }
        /**
         * Error messages for Date of Birth (DOB) validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         * - minDate: (optional) Error if the DOB is before a very old date (not needed here)
        */
        const dobErrorMsg = {
            futureDate: AUTH_STRINGS.ERRORS.AUTH_SIGNATORY_FUTURE,
            maxDate: AUTH_STRINGS.ERRORS.AUTH_SIGNATORY_LESS_THAN_18,
        }
        /**
         * Error messages for Date of Birth (DOB) Beneficial Owner validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         */
        const dobErrorBenfical = {
            futureDate: AUTH_STRINGS.ERRORS.BENIFICIAL_OWNER_FUTURE,
            maxDate: AUTH_STRINGS.ERRORS.BENIFICIAL_OWNER_LESS_THAN_18,
        }
        /**
         * Error messages for Date of Birth (DOB) Authorized Signatory validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         */
        const dobError = {
            futureDate: watch('authSignatory') === 'yes' ? dobErrorMsg.futureDate : dobErrorBenfical.futureDate,
            maxDate: watch('authSignatory') === 'yes' ? dobErrorMsg.maxDate : dobErrorBenfical.maxDate,
        };

        /**
        * Method fetches data from the state
        */
        const businessState = useSelector((state: any) =>
            fetchDataFromState(state, 'customer-kyc-data')
        );

        /**
         * Method handles the dates validation for Date of Birth (DOB) field
         * @param value 
         * @param fieldName 
         */
        const handleOnChangeEventForDate = (value: any, fieldName: string) => {
            handleDateValidation("dob", value, setValue, setError, clearErrors, true, ageLimit(18),null,dobError)
            saveNodeData('ownership-info-page', 'dob', value, setValue, getValues,  dispatch, businessState, props?.index);
        }

        /**
             * Method handles the change event for the state dropdown field
             * @param e 
             * @param fieldName 
             */
            const handleStateOnChangeEvents = (e: any, fieldName: string) => {
                handleFieldChange('state', e, setValue, clearErrors);
                saveNodeData('ownership-info-page', fieldName, e, setValue, getValues,  dispatch, businessState, props?.index);
            }


        return (
            <Grid container id='signUp-business-owner' xs={12} className='fx-business-owner-add'>
                <FxCard id="signUp-business-owner-form-card" className={isSmallScreen?"fx-theme-passport fx-business-owner-add-border":"fx-theme-passport"}>
                    <FxCardHeader>
                      <Typography className='fx-new-invite-owner-profile-label'>{props?.data ? props?.data?.length + 1 + ". " : 1 + ". "}Beneficial Owner</Typography>
                    </FxCardHeader>
                    <div className="fx-form-edit-profile">
                        <form id="signUp-business-owner-form" onSubmit={handleSubmit(onSubmit)}>
                            <FxCardBody id="signUp-business-owner-form-card-body" className="fx-info-card" >
                                <Grid container direction="row" spacing={2} className="fx-info-card-form" >
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("firstName") }} className={errors.firstName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-first-name" label="Legal First Name" name="firstName" variant="outlined" 
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'firstName', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='firstName'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("lastName") }} className={errors.lastname ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-last-name" label="Legal Last Name" name="lastName" variant="outlined" 
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'lastName', e, setValue, getValues,  dispatch, businessState, props?.index)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='lastName' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("email") }}  className={errors.email ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setEmailValidationOptions} id="signUp-business-owner-form-card-email" label="Email" name="email" variant="outlined" onChange={(e: any) => { handleEmailChange(e, setValue, setError, clearErrors) }} 
                                            onBlur={(e) => saveNodeData('ownership-info-page', 'email', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='email' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("jobtitle") }} className={errors.jobtitle ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-jobTitle" label="Job Title" name="jobtitle"
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'jobtitle', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='jobtitle' />
                                    </Grid>
                                    <Grid item xs={12} sm={12} >
                                    <FxTextEdit register={{ ...register("ownerShipPercentage") }} className={errors.ownerShipPercentage ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setOwnerShipPercentageRule} id="signUp-business-owner-form-card-ownerShipPercentage" type="number" label={authSignDate === true ? "Ownership" : "Ownership"} suffix="%" name="ownerShipPercentage" variant="outlined" setValue={setValue} min='0'
                                    onBlur={(e) => saveNodeData('ownership-info-page', 'ownerShipPercentage', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                    <FieldErrorMessageRender error={errors} fieldKey='ownerShipPercentage' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >ABOUT OWNER</FxLabelView>
                                    </Grid>
                                    <Grid item sm={12} xs={12}>
                                        <FxDateEdit register={{ ...register("dob") }} className={errors.dob ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-dob" label="Date of Birth" name="dob" variant="outlined" maxDate={ageLimit(18)} setValue={setValue} defaultCalendarMonth={ageLimit(18)} onChange={(value) => handleOnChangeEventForDate(value, 'dob')} ageLimitMessage={dobError.maxDate} futureDateMessage={dobError.futureDate}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='dob' type='date' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxPhoneEdit register={register} className={errors.mobilePhone ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setPhoneValidationOptions(true)} id="signUp-business-owner-form-card-mobilePhone" label="Mobile Number" name="mobilePhone" placeholder={'XXX-XXX-XXXX'} setValue={setValue} setError={setError} clearErrors={clearErrors} 
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'mobilePhone', e, setValue, getValues,  dispatch, businessState, props?.index)} />
                                        <FieldErrorMessageRender error={errors} fieldKey='mobilePhone' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxMaterialSelect register={{ ...register("usCitizen") }} rules={{ required: true }} className={errors.usCitizen ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} id="signUp-business-owner-select-usCitizen" name="usCitizen" data={usCitizenDropdown} label="Is US Citizen" setValue={setValue} value={'US_CITIZEN'} 
                                          onChange={(e) => saveNodeData('ownership-info-page', 'usCitizen', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                    </Grid>

                                    {/*** Identification Info Fields ***/}
                                    <Grid container item xs={12} sm={12} display={'flex'} alignItems={'center'}>
                                        <Grid item>
                                            <FxLabelView id="business-owner-details-label" className="" >IDENTIFICATION INFO</FxLabelView>
                                        </Grid>
                                        <Grid item xs={1} container justifyContent="center" alignItems="center">
                                            {ShowInfoToolTip('fx-business-owner-title-tooltip', 'We will use tax identifier to verify your identity and will not check your credit score', 'bottom-start')}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs ={12} sm={12}>
                                        <FxMaterialSelect
                                            register={{ ...register("taxIdentifier") }}
                                            control={control}
                                            rules={{ required: false }}
                                            id="signUp-indivudal-form-card-tax-identifier"
                                            name="taxIdentifier"
                                            data={taxIdentifierData}
                                            value="ssn"
                                            label="Identification Method"
                                            setValue={setValue}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} sm={12} alignItems="center">
                                    <Grid item xs={isMobileScreen?11:12} sm={11}>
                                        <FxTextEditSSN
                                            key={taxIdentifier}
                                            register={{ ...register(taxIdentifier) }}
                                            className={errors.ssn || errors.itin ? "border-error-input fx-input-edit" : "fx-input-edit"}
                                            error={errors?.ssn || errors?.itin}
                                            control={control}
                                            rules={taxIdentifier === 'ssn' ? {...setSsnValidationOptions(true)} : {...setItinValidationOptions(true)}}
                                            id="signUp-indivudal-form-card-ssn-itin"
                                            label={`${taxIdentifier === 'ssn' ? 'Social Security Number' : 'Individual Taxpayer Identification Number'}`}
                                            placeholder="XXX-XX-XXXX"
                                            name={taxIdentifier}
                                            variant="outlined"
                                            setValue={setValue}
                                            setError={setError}
                                            clearErrors={clearErrors}
                                            onBlur={(e: any) => 
                                                    saveNodeData('ownership-info-page', taxIdentifier, e, setValue, getValues,  dispatch, businessState, props?.index)
                                            }
                                        />                                   
                                    </Grid>
                                    <Grid item xs={isMobileScreen?1:12} sm={1} container justifyContent="center" alignItems="center">
                                        {ShowInfoToolTip('fx-business-owner-title-tooltip', 'We will use tax identifier to verify your identity and will not check your credit score', 'bottom-end')}
                                    </Grid>
                                    </Grid>
                                    <Grid item xs={isMobileScreen ? 11 : 12} sm={11} className="fx-individual-details-error-row" >
                                        <FieldErrorMessageRender error={errors} fieldKey={taxIdentifier === 'ssn' ? 'ssn' : 'itin'} />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >SECONDARY IDENTIFICATION</FxLabelView>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FxMaterialSelect register={{ ...register('secondaryIdentificationType') }} control={control} className={errors['secondaryIdentificationType'] ? "border-error-input fx-input-edit" : "fx-input-edit"} rules={{ required: true }} id={'secondaryIdentificationType'} name={'secondaryIdentificationType'} data={secondaryIDTypeData}
                                             onChange={(e)=>handleChange(e,'secondaryIdentificationType')}label="Type " setValue={setValue} />
                                             <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationType' />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FxTextEdit register={{ ...register("secondaryIdentificationId") }} className={errors.secondaryIdentificationId ? "border-error-input fx-input-edit login-email fs-mask" : "fx-input-edit login-email fs-mask"} control={control} rules={secondaryIdentificationIdValidation(secondaryIdType)} id="signup-secondaryIdentificationId" label="ID " name="secondaryIdentificationId" onChange={(e: any) => { handleSecIdChange(e, setValue, setError, clearErrors, secondaryIdType) }} onBlur={(e) => saveNodeData('ownership-info-page', 'secondaryIdentificationId', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationId' />
                                    </Grid>
                                    {secondaryIdType === 'DRIVER_LICENSE' &&
                                        <Grid item xs={12} sm={4}>
                                            <FxMaterialSelect register={{ ...register('secondaryIdentificationIssuanceState') }} control={control} className={errors['secondaryIdentificationIssuanceState'] ? "border-error-input fx-input-edit" : "fx-input-edit"} rules={{ required: true }} id={'secondaryIdentificationIssuanceState'} name={'secondaryIdentificationIssuanceState'} data={usa_state}
                                                 onChange={(e)=>handleChange(e,'secondaryIdentificationIssuanceState')}  label="State of Issuance " setValue={setValue} />
                                                 <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationIssuanceState' />
                                        </Grid>}
                                    {secondaryIdType !== 'DRIVER_LICENSE' && secondaryIdType !== 'ALIEN_REGISTRATION_CARD' && <Grid item xs={12} sm={4}>
                                        <FxMaterialSelect register={{ ...register('secondaryIdentificationIssuance') }} control={control} className={errors['secondaryIdentificationIssuance'] ? "border-error-input fx-input-edit" : "fx-input-edit"} rules={{ required: secondaryIdType !== '' ? true : false }} id={'secondaryIdentificationIssuance'} name={'secondaryIdentificationIssuance'} data={issuance_countries}
                                             onChange={(e)=>handleChange(e,'secondaryIdentificationIssuance')} readOnly={secondaryIdType === 'ALIEN_REGISTRATION_CARD' ? true : false} label="Country of Issuance " setValue={setValue} />
                                             <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationIssuance' />
                                    </Grid>}
                                    {secondaryIdType === 'ALIEN_REGISTRATION_CARD' &&
                                        <Grid item xs={12} sm={4}>
                                            <FxTextEdit register={{ ...register("secondaryIdentificationIssuanceAlien") }} className={errors.secondaryIdentificationIssuanceAlien ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"}
                                                control={control} id="signUp-business-owner-secondaryIdentificationIssuanceAlien" label="Country of Issuance " name="secondaryIdentificationIssuanceAlien" defaultValue="US" isEditable={false} />
                                            <FieldErrorMessageRender error={errors} fieldKey='secondaryIdentificationIssuanceAlien' />
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >PRIMARY ADDRESS</FxLabelView>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("addressLine1") }} className={errors.addressLine1 ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"}  rules={setAddressLine1Validation(true)} control={control} id="signUp-business-owner-addressLine1" label="Address Line 1" name="addressLine1" 
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'addressLine1', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='addressLine1' />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("addressLine2") }} className={errors.addressLine2 ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: false }} id="signUp-business-owner-addressLine2" label="Address Line 2 (optional)" name="addressLine2" 
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'addressLine1', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("city") }} className={errors.city ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setCityValidation(true)} id="signUp-business-owner-city" label="City" name="city" 
                                        onBlur={(e) => saveNodeData('ownership-info-page', 'city', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='city' />
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FxMaterialSelect register={{ ...register("state") }} rules={{ required: true }} className={errors.state ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} id="signUp-business-owner-select-state" name="state" data={usa_state} label="State" setValue={setValue} value={''}
                                        onChange={(e) => handleStateOnChangeEvents(e, 'state')}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='state' />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FxTextEdit register={{ ...register("zip") }} className={errors.zip ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setZipValidationOptions(true)} id="signUp-business-owner-zip" label="Zip" name="zip" onChange={(e: any) => { handleZipChange(e, setValue, setError, clearErrors) }} onKeyDown={(e: any) => { handleKeyDownChange(e, setValue) }} 
                                            onBlur={(e) => saveNodeData('ownership-info-page', 'zip', e, setValue, getValues,  dispatch, businessState, props?.index)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='zip' />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Grid container alignItems="center" >
                                            <Grid item xs={12} sm={12}>
                                                <FxLabelView id="business-owner-details-label" className="">Do you have substantial control over company's finances and will act as authorized signatory for the account?</FxLabelView>
                                            </Grid>
                                            <Grid item xs={12} sm={12} alignItems="center">
                                                <FxRadioEdit register={{ ...register("authSignatory") }} control={control} className={errors.authSignatory ? "border-error-input fx-input-edit kyc-radio-edit" : "fx-input-edit kyc-radio-edit"} data={setAsAuthSignatoryRadioButtonData} id="signUp-business-owner-form-card-authSignatory" name="authSignatory" row="vertical" setValue={setValue} onChange={handleSetAsAuthSignatoryRadioButtonChange} defaultValue={watch('authSignatory')}/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Divider />
                                    </Grid>
                                </Grid>
                            </FxCardBody>
                            <FxCardFooter id="signUp-business-owner-Card-Footer" className="fx-footer">
                                <Grid container direction="row" justifyContent="flex-end" className="fx-modal-footer">
                                    <FxButton
                                        disableRipple={false}
                                        variant="contained"
                                        className="fx-button fx-button-cancel"
                                        id="cancel-add-business-owner-btn"
                                        onClick={handleGoBackClick}
                                    > CANCEL
                                    </FxButton>
                                    <Grid className='fx-padding-right-15'></Grid>
                                    <FxButton
                                        disableRipple={false}
                                        className="fx-button fx-button-theme"
                                        id="save-add-business-owner-btn"
                                        type="submit"
                                        isSubmitting={isSubmitting}
                                    > Save
                                    </FxButton>
                                </Grid>
                            </FxCardFooter>
                        </form>
                    </div>
                </FxCard>
            </Grid>
        )
    }
)
